<template>
  <span
    :style="{
      color,
    }"
  >
    {{ _profitData }}
  </span>
</template>
<script>
import { mapState } from 'vuex'
import { Big } from 'big.js'
export default {
  props: {
    profitData: Object,
  },
  computed: {
    ...mapState('contract', ['quotes']),
    _profitData() {
      const { contractNo, openPrice, positionData, direction, unit, amount } =
        this.profitData
      const quote = this.quotes.find(
        (item) => item.contractNo === contractNo.toUpperCase()
      )
      if (!quote) return ''
      let ret
      if (positionData) {
        ret = positionData.reduce((calc, item) => {
          return Big(quote.price)
            .minus(item.openPrice)
            .mul(item.direction.toUpperCase() === 'BULL' ? 1 : -1)
            .mul(item.unit)
            .mul(item.amount)
            .plus(calc)
        }, Big(0))
      } else {
        ret = Big(quote.price)
          .minus(openPrice)
          .mul(direction.toUpperCase() === 'BULL' ? 1 : -1)
          .mul(unit)
          .mul(amount)
      }
      const retStr = ret.toString()
      return `${ret.gte(0) ? '+' : ''}${retStr}`
    },
    color() {
      return +this._profitData >= 0 ? '#02B999' : '#FF3F4A'
    },
  },
}
</script>
